<template>
  <div class="m-[12px]">
    <div class="flex gap-[10px] items-start flex-col sm:flex-row flex-wrap">
      <div class="flex items-center justify-center flex-shrink-0 size-[69px] rounded-lg overflow-hidden">
        <img
          :src="warehouseImageUrl"
          alt="warehouse logo"
          width="69"
          height="69"
          class="h-[69px] w-[69px]"
          @error="handleImageError"
        >
      </div>
      <div class="flex-1">
        <div class="flex items-center gap-[6px] flex-wrap">
          <img
            src="https://storage.googleapis.com/komerce/assets/logo/logo-only/Logo-kompack.svg"
            alt="kompack"
            width="36"
            height="36"
          >
          <div class="font-semibold text-black">
            {{ item.warehouse_name }}
          </div>
          <img
            v-if="item.is_main"
            src="https://storage.googleapis.com/komerce/assets/svg/gudang-utama-orange.svg"
            alt="utama"
            width="26"
            height="26"
            class="mb-[2px] ml-[6px]"
          >
        </div>
        <div class="text-black text-[12px] !capitalize">
          {{ item.location.toLowerCase() }}
        </div>
        <div class="text-[#828282] text-[10px]">
          Berlangganan : {{ DAY_MONTH_YEAR(item.subscribed_date) }}
        </div>
      </div>
      <b-button
        variant="outline-primary"
        size="sm"
        @click="goToDetail"
      >Detail</b-button>
    </div>
  </div>
</template>

<script>
import { DAY_MONTH_YEAR } from '@/libs/formatDate'

export default {
  name: 'WarehouseCardHeader',
  props: {
    item: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    warehouseImageUrl() {
      return this.item.warehouse_image_url || 'https://storage.googleapis.com/komerce/assets/icons/product-placehold.svg'
    },
  },
  methods: {
    DAY_MONTH_YEAR,
    handleImageError() {
      this.item.warehouse_image_url = 'https://storage.googleapis.com/komerce/assets/icons/product-placehold.svg'
    },
    goToDetail() {
      this.$router.push({ name: 'detail-gudang-kompack', params: { id: this.item.mitra_id }, query: { wid: this.item.warehouse_id } })
    },
  },
}
</script>
